var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconScreenRecorderRecordingGnbMicOff = function SvgIconScreenRecorderRecordingGnbMicOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.976 12.705c.27.553.686 1.005 1.192 1.3m3.666 0a2.85 2.85 0 0 0 1.08-1.064c.267-.454.416-.977.433-1.516V5.848c-.072-.891-.464-1.716-1.091-2.294a2.95 2.95 0 0 0-2.255-.794 2.95 2.95 0 0 0-2.249.799 3.5 3.5 0 0 0-1.088 2.29v2.518m9.451 2.26a7.2 7.2 0 0 1-.485 2.553 6.7 6.7 0 0 1-1.348 2.153 5.4 5.4 0 0 1-.614.67m-2.585 1.18a5.67 5.67 0 0 1-3.891-.642c-1.197-.675-2.156-1.763-2.729-3.094a7.2 7.2 0 0 1-.576-2.82M12 21.25v-3.998m3.337 3.998H8.664"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E55845",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.667 4.012 3.997 4.357 5.16 5.627 1.816 1.979 3.694 4.027"
  })));
};
export default SvgIconScreenRecorderRecordingGnbMicOff;